import { useEffect, useState } from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EstateTaskInstance } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import { useStyles } from './estate-checklist-start-new-search-menu.styles';
import { EstateSearchTaskInstancesModal } from './estate-search-task-instances-modal';

interface Props {
  estateSearchTaskInstances: EstateTaskInstance[];
  estateTaskColumns: GridColDef[];
  featureSubscriptionTypeLoading: boolean;
}

export const EstateChecklistStartNewSearchMenu = ({
  estateSearchTaskInstances,
  featureSubscriptionTypeLoading,
  estateTaskColumns,
}: Props) => {
  const classes = useStyles();

  const [showEstateSearchTaskInstancesModal, setShowEstateSearchTaskInstancesModal] =
    useState<boolean>(false);
  const [selectedEstateSearchTaskInstance, setEstateSelectedSearchTaskInstance] =
    useState<EstateTaskInstance>();
  const [duplicateEstateSearchTaskInstances, setDuplicateEstateSearchTaskInstances] = useState<
    EstateTaskInstance[]
  >([]);

  const onAssignClick = (instance: EstateTaskInstance) => {
    setEstateSelectedSearchTaskInstance(instance);
    setShowEstateSearchTaskInstancesModal(true);
  };

  useEffect(() => {
    if (selectedEstateSearchTaskInstance) {
      const duplicatedSearchTaskInstances = estateSearchTaskInstances.filter(
        (instances) => instances.estateTaskId === selectedEstateSearchTaskInstance.estateTaskId,
      );
      setDuplicateEstateSearchTaskInstances(duplicatedSearchTaskInstances);
    }
  }, [selectedEstateSearchTaskInstance, estateSearchTaskInstances]);

  const getUniqueSearchTaskInstances = (estateSearchTaskInstances: EstateTaskInstance[]) =>
    estateSearchTaskInstances.filter(
      ({ estateTaskId }, index, self) =>
        self.findIndex((t) => t.estateTaskId === estateTaskId) === index,
    );

  if (estateSearchTaskInstances.length <= 0) {
    showAlert({
      message: 'Error loading the Estate Search Task Instances!',
      severity: NotificationSeverity.ERROR,
    });
  }

  return (
    <Box className={classes.container}>
      <Typography className={classes.heading}>Start New Search</Typography>
      <Box className={classes.menuButtons}>
        {getUniqueSearchTaskInstances(estateSearchTaskInstances).map((instance) => (
          <>
            <Button
              key={instance.estateTaskId}
              className={classes.button}
              onClick={() => onAssignClick(instance)}
            >
              {instance?.shortName}
            </Button>
          </>
        ))}
      </Box>
      <Divider />

      {showEstateSearchTaskInstancesModal && (
        <EstateSearchTaskInstancesModal
          modalOpen={showEstateSearchTaskInstancesModal}
          setShowModal={setShowEstateSearchTaskInstancesModal}
          estateSearchTaskInstances={duplicateEstateSearchTaskInstances!}
          estateTaskColumns={estateTaskColumns}
          featureSubscriptionTypeLoading={featureSubscriptionTypeLoading}
        />
      )}
    </Box>
  );
};
